import styled from 'styled-components';
import media from '../../../constants/media';
import DynamicRspImage from '../../base/images/dynamicRspImageBg';

export const Wrapper = styled.div``;

export const ServicePortalTile = styled.a`
	display: block;
	position: relative;
	width: 150vw;
	max-width: 50rem;
	margin: 0 auto;
	z-index: 2;

	${media.tablet`
	`};
`;

export const ServicePortalImage = styled(DynamicRspImage)`
	padding-top: 60%;
`;

export const ServiceTileContent = styled.div`
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
	font-size: 2rem;
	background-color: #fff;
	padding: 3rem 5rem 5rem 5rem;

	p {
		margin-top: 1rem;
		width: 100%;
		font-family: ${({ theme }) => theme.fonts.ArimoRegular};
		font-size: 1.5rem;
	}

	button {
		margin-top: 3rem;
		width: 100%;
	}
`;